<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-select v-model="locale" @change="resetList">
              <el-option v-for="e in i18nConfig.locales" :key="e" :label="e" :value="e"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">查询</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="center" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" label="name" prop="code" min-width="200" />
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="updateTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.updateTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button @click="openDialog(scope.row)" type="primary" size="mini"> 编辑 </el-button>
            <el-button @click="handleDelete(scope.row.id)" size="mini" type="danger">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="dialogVisible" width="800px">
      <el-form class="post-main-container post-dialog-container long" label-position="right">
        <el-form-item label="name：" required>
          <el-input disabled v-model.trim="currentRow.code" />
        </el-form-item>
        <el-form-item label="content：" required>
          <div v-if="['QA', 'TAG', 'LINK'].includes(currentRow.type)">
            <div class="grid-box">
              <div
                :class="['point-box', { active: index === contentIndex }]"
                v-for="(e, index) in currentRow.content"
                :key="index"
                @click="setActive(index)"
              >
                {{ index + 1 }}
              </div>
            </div>
            <div style="margin-bottom: 10px" v-if="currentRow.content.length">
              <template v-if="currentRow.type === 'LINK'">
                <el-form-item label="title：" required>
                  <el-input v-model.trim="currentRow.content[contentIndex].text" />
                </el-form-item>
                <el-form-item label="link：" required>
                  <el-input v-model.trim="currentRow.content[contentIndex].link" />
                </el-form-item>
                <el-form-item label="logo：">
                  <upload-image
                    :originData="currentRow.content[contentIndex].value"
                    @postImage="updateLogo"
                    :limit="1"
                    :key="contentIndex"
                    @deleteImageUrl="onDeleteLogo"
                  />
                </el-form-item>
              </template>

              <template v-if="currentRow.type === 'QA'">
                <el-form-item label="Q：" required>
                  <el-input v-model.trim="currentRow.content[contentIndex].text" />
                </el-form-item>
                <el-form-item label="A：" required>
                  <el-input type="textarea" v-model="currentRow.content[contentIndex].value" />
                </el-form-item>
              </template>
              <el-form-item v-if="currentRow.type === 'TAG'" label="选择分类" required>
                <el-select
                  v-model="currentRow.content[contentIndex].id"
                  placeholder="请选择"
                  filterable
                  remote
                  :loading="selectLoading"
                  :remote-method="getTags"
                  @change="onSelect"
                  :key="contentIndex"
                >
                  <el-option
                    v-for="item in tags"
                    :key="item.id"
                    :label="item.content"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="currentRow.type === 'TAG'" label="名称自定义">
                <el-input v-model.trim="currentRow.content[contentIndex].content" />
              </el-form-item>
            </div>
            <el-button @click="addItem" size="mini">新增</el-button>
            <el-button @click="deleteItem" type="danger" size="mini">删除</el-button>
          </div>
          <el-input
            v-else-if="currentRow.type === 'TEXTAREA'"
            type="textarea"
            v-model.trim="currentRow.content"
          />
          <el-input v-else v-model.trim="currentRow.content" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="btnLoading" @click="postEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConfigs, updateConfig } from '@/api/setting'
import { getCategories } from '@/api/categories'
import { i18nConfig } from '@/utils'

export default {
  data() {
    return {
      i18nConfig,
      locale: i18nConfig.defaultLocale,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        limit: 10,
        current: 1
      },

      btnLoading: false,
      dialogVisible: false,
      currentRow: {},
      contentIndex: 0,

      selectLoading: false,
      tags: []
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    onSelect(tagId) {
      const tag = this.tags.find((e) => e.id === tagId)
      if (tag) {
        const { content, slugName, type } = tag
        const parent = this.currentRow.content[this.contentIndex]
        parent.content = content
        parent.slugName = slugName
        parent.type = type
      }
    },

    getTags(content) {
      this.selectLoading = true
      getCategories(
        {
          content,
          auditStatus: 'APPROVED',
          status: 'AVAILABLE'
        },
        this.locale
      )
        .then((res) => {
          this.tags = res.result.rows
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    updateLogo(e) {
      this.currentRow.content[this.contentIndex].value = e
    },

    onDeleteLogo() {
      this.currentRow.content[this.contentIndex].value = ''
    },

    setActive(index) {
      this.contentIndex = index
    },

    deleteItem() {
      if (!this.currentRow.content) return
      if (!this.currentRow.content.length) return
      this.currentRow.content.splice(this.contentIndex, 1)
      this.contentIndex = 0
    },

    addItem() {
      let item = {}
      switch (this.currentRow.type) {
        case 'LINK':
          item = {
            text: '',
            link: '',
            value: ''
          }
          break
        case 'QA':
          item = {
            text: '',
            value: ''
          }
          break
        case 'TAG':
          item = {
            id: '',
            content: '',
            slugName: '',
            type: ''
          }
          break
        default:
          break
      }
      this.currentRow.content.push(item)
      this.contentIndex = Math.max(this.currentRow.content.length - 1, 0)
    },

    checkFormFull() {
      const { code, content, type } = this.currentRow
      if ([code, content].includes('')) {
        this.$message.error('请填写必填项')
        return false
      }
      if (type === 'LINK') {
        const idx = content.findIndex((e) => !e.value || !e.text || !e.link)
        if (idx !== -1) {
          this.$message.error(`请填写 content 第${idx + 1}项`)
          return false
        }
      }

      if (type === 'QA') {
        const idx = content.findIndex((e) => !e.value || !e.text)
        if (idx !== -1) {
          this.$message.error(`请填写 content 第${idx + 1}项`)
          return false
        }
      }

      if (type === 'TAG') {
        const idx = content.findIndex((e) => !e.id || !e.slugName)
        if (idx !== -1) {
          this.$message.error(`请填写 content 第${idx + 1}项`)
          return false
        }
      }
      return true
    },

    postEdit() {
      const form = JSON.parse(JSON.stringify(this.currentRow))
      if (!this.checkFormFull()) return
      this.btnLoading = true
      this.handleUpdate(form)
        .then(() => {
          this.dialogVisible = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        updateConfig(row, this.locale)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    openDialog(row) {
      this.currentRow = JSON.parse(JSON.stringify(row))
      this.contentIndex = 0
      this.dialogVisible = true
      if (row.type === 'TAG') {
        this.tags = row.content || []
      }
    },

    resetList() {
      this.query.current = 1
      this.getList()
    },

    getList() {
      this.listLoading = true
      getConfigs(this.query, this.locale).then((res) => {
        this.list = res.result.rows
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-box {
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 10px;
}

.point-box {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  border: 1px solid #006fff;

  &.active {
    background-color: #006fff;
    color: #fff;
  }
}
</style>
